import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/**
 * Hook che sincronizza la lingua dell'utente autenticato con i18next.
 * Deve essere utilizzato SOLO nei componenti protetti (dopo login).
 * 
 * Logica:
 * 1. Al mount, legge preferred_language da Redux
 * 2. Se diversa da i18n.language, aggiorna i18next (e localStorage)
 * 3. Non tocca il DB (la sincronizzazione è già stata fatta al login)
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  const userLanguage = useSelector((state) => state.user.user?.profile?.preferred_language);
  const isAuth = useSelector((state) => state.user.isAuth);

  useEffect(() => {
    if (isAuth && userLanguage && i18n.language !== userLanguage) {
      console.log(`[useLanguageSync] Sincronizzazione lingua: ${i18n.language} → ${userLanguage}`);
      i18n.changeLanguage(userLanguage);
    }
  }, [isAuth, userLanguage, i18n]);
}